// extracted by mini-css-extract-plugin
export default {"disableLink":"Nk-z"};